export default __webpack_public_path__ + "static/B0309-185b3ebbf8ed42d99982565244794a27.png";